import type { EffectDefinition, EffectContext } from './types'

interface Particle {
  x: number
  y: number
  vx: number
  vy: number
  radius: number
  opacity: number
  baseOpacity: number
  phase: number
}

function createParticle(width: number, height: number): Particle {
  const baseOpacity = 0.15 + Math.random() * 0.3
  return {
    x: Math.random() * width,
    y: Math.random() * height,
    vx: (Math.random() - 0.5) * 15,
    vy: (Math.random() - 0.5) * 15,
    radius: 1 + Math.random() * 2.5,
    opacity: baseOpacity,
    baseOpacity,
    phase: Math.random() * Math.PI * 2
  }
}

export const particles: EffectDefinition = {
  id: 'particles',
  name: 'Floating Particles',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 8000)
    const items: Particle[] = []
    for (let i = 0; i < count; i++) {
      items.push(createParticle(ctx.width, ctx.height))
    }
    return items
  },

  update(state: unknown, ctx: EffectContext) {
    const items = state as Particle[]
    const dt = ctx.deltaTime / 1000
    for (const p of items) {
      p.x += p.vx * dt
      p.y += p.vy * dt
      p.opacity = p.baseOpacity + Math.sin(ctx.time / 1000 + p.phase) * 0.1

      // Wrap around edges
      if (p.x < -10) p.x = ctx.width + 10
      if (p.x > ctx.width + 10) p.x = -10
      if (p.y < -10) p.y = ctx.height + 10
      if (p.y > ctx.height + 10) p.y = -10
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const items = state as Particle[]
    const { ctx: c } = ctx
    for (const p of items) {
      c.beginPath()
      c.arc(p.x, p.y, p.radius, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 255, 255, ${Math.max(0, p.opacity)})`
      c.fill()
    }
  }
}
